const translation = {
  welcome: 'wilkommen',
}

export { translation }
